import { render, staticRenderFns } from "./TermsListComponent.vue?vue&type=template&id=027637e3&scoped=true&"
import script from "./TermsListComponent.vue?vue&type=script&lang=js&"
export * from "./TermsListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027637e3",
  null
  
)

export default component.exports